<template>
  <!-- eslint-disable -->
  <div class="medical-professional-wrapper">
    <ModalAgregarHorario :profesional_id="Number($route.params.id)" ref="modalagregarhorario" />
    <ModalModificarAtencionPrestador :profesional_id="Number($route.params.id)" ref="modalatencion" />
    <ModalModificarProfesional ref="modalmodificarprofesional" />

    <div class="column-left">
      <SideNav />
    </div>

    <div class="column-right">
      <TopNav />
      <div class="main-container">
        <div v-if="loaded" class="professional-content">
          <!-- Back Button -->
          <div style="margin-bottom: 25px; text-align: left;">
            <button 
              class="btn-ir-gordo" 
              :style="{
                'background-color': prestador.admin.assets.colors.primary,
                color: 'white',
                display: 'inline-flex',
                'align-items': 'center',
                gap: '8px',
                padding: '10px 20px',
                'border-radius': '10px',
                border: 'none',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                'font-weight': '600'
              }"
              @click="$router.push({ name: 'Profesionales' })"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>
              Volver a Profesionales
            </button>
          </div>

          <div class="professional-layout">
            <!-- Professional Profile Card -->
            <div class="profile-card">
              <div class="profile-header">
                <div class="profile-avatar-container">
                  <div class="profile-avatar" :style="{
                    'background-image': profesional.atributos && profesional.atributos.hasOwnProperty('foto') ? 'url(https://assets-fotos-profesionales.s3.sa-east-1.amazonaws.com/' + profesional.atributos.foto + ')' : 'url(' + require('@/assets/ia/emptyuser.webp') + ')',
                    'border-color': prestador.admin.assets.colors.secondary
                  }"></div>
                  <div class="profile-status-indicator"
                    :style="{ 'background-color': prestador.admin.assets.colors.primary }"></div>
                </div>

                <div class="profile-info">
                  <h1 class="profile-name">
                    {{ profesional.nombre }} {{ profesional.apellido }}
                    <button class="edit-profile-btn" @click="$refs.modalmodificarprofesional.show(profesional)"
                      :style="{ 'color': prestador.admin.assets.colors.primary }">
                      <i class="tf-icons ti ti-pencil"></i>
                    </button>
                  </h1>
                  <p class="profile-role">Profesional Médico</p>
                </div>
              </div>

              <div class="profile-divider"></div>

              <div class="profile-details">
                <div class="details-header">
                  <h3>Información del Profesional</h3>
                </div>

                <div class="details-grid">
                  <div v-if="prestador.id == 1" class="detail-item full-width">
                    <div class="detail-label">
                      <div class="detail-icon">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                          stroke-width="2">
                          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                          <circle cx="9" cy="7" r="4"></circle>
                          <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                          <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                        </svg>
                      </div>
                      Atiende a:
                    </div>
                    <div class="detail-value">
                      <div class="provider-tags">
                        <span v-for="s in profesional.atiende_prestadores" :key="s.id" class="provider-tag" :style="{
                          'color': prestador.admin.assets.colors.secondary,
                          'border-color': prestador.admin.assets.colors.secondary,
                          'background-color': prestador.admin.assets.colors.secondary + '10'
                        }">
                          {{ s.nombre }}
                        </span>
                      </div>
                      <button class="modify-btn" @click="$refs.modalatencion.show()"
                        :style="{ 'background-color': prestador.admin.assets.colors.primary }">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                          stroke-width="2">
                          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                        </svg>
                        Modificar
                      </button>
                    </div>
                  </div>

                  <div class="detail-item">
                    <div class="detail-label">
                      <div class="detail-icon">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                          stroke-width="2">
                          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                          <polyline points="22,6 12,13 2,6"></polyline>
                        </svg>
                      </div>
                      Email:
                    </div>
                    <div class="detail-value">{{ profesional.email }}</div>
                  </div>

                  <div class="detail-item">
                    <div class="detail-label">
                      <div class="detail-icon">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                          stroke-width="2">
                          <path
                            d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z">
                          </path>
                        </svg>
                      </div>
                      Teléfono:
                    </div>
                    <div class="detail-value">{{ profesional.telefono == null ? 'Sin especificar' : profesional.telefono
                      }}</div>
                  </div>

                  <div class="detail-item">
                    <div class="detail-label">
                      <div class="detail-icon">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                          stroke-width="2">
                          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                          <polyline points="14,2 14,8 20,8"></polyline>
                          <line x1="16" y1="13" x2="8" y2="13"></line>
                          <line x1="16" y1="17" x2="8" y2="17"></line>
                          <polyline points="10,9 9,9 8,9"></polyline>
                        </svg>
                      </div>
                      RUT:
                    </div>
                    <div class="detail-value">{{ profesional.rut }}</div>
                  </div>

                  <div class="detail-item">
                    <div class="detail-label">
                      <div class="detail-icon">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                          stroke-width="2">
                          <circle cx="12" cy="12" r="10"></circle>
                          <polyline points="12,6 12,12 16,14"></polyline>
                        </svg>
                      </div>
                      Tiempo asignado:
                    </div>
                    <div class="detail-value">
                      <span class="time-badge">
                        {{timeConvert(profesional.horarios.reduce((x, y) => {
                          return x + (y.prioridad == 1 ? (y.termino - y.inicio) * (y.repeticion.split("1").length - 1) : 0)
                        }, 0)) }} hrs
                      </span>
                    </div>
                  </div>

                  <div class="detail-item">
                    <div class="detail-label">
                      <div class="detail-icon">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                          stroke-width="2">
                          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                          <circle cx="12" cy="10" r="3"></circle>
                        </svg>
                      </div>
                      Atiende en:
                    </div>
                    <div class="detail-value">
                      <div class="location-tags">
                        <span v-for="c, index in profesional.comunas" :key="c" class="location-tag">
                          {{comunas.find(x => x.id == c).Nombre}}{{ index == profesional.comunas.length - 1 ? '' : ',' }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="detail-item">
                    <div class="detail-label">
                      <div class="detail-icon">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                          stroke-width="2">
                          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                          <polyline points="22,6 12,13 2,6"></polyline>
                        </svg>
                      </div>
                      Categorías:
                    </div>
                    <div class="detail-value">
                      <div class="category-tags">
                        <span v-for="c, index in profesional.categorias" :key="c" class="category-tag">
                          {{categorias.find(x => x.id == c).nombre}}{{ index == profesional.categorias.length - 1 ? '' : ','
                          }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Main Content Area -->
            <div class="content-area">
              <!-- Tab Navigation -->
              <div class="tab-navigation">
                <div class="tab-container">
                  <button v-for="t in top_menu" :key="t.nombre" @click="viendo_top_menu = t.nombre" class="tab-button"
                    :class="{ 'active': viendo_top_menu == t.nombre }" :style="{
                      'background-color': viendo_top_menu == t.nombre ? prestador.admin.assets.colors.primary : '',
                      'color': viendo_top_menu == t.nombre ? '#fff' : '',
                      'border-color': viendo_top_menu == t.nombre ? prestador.admin.assets.colors.primary : ''
                    }">
                    <i :class="t.icono" class="tab-icon tf-icons ti"></i>
                    <span class="tab-text">{{ t.nombre }}</span>
                  </button>
                </div>
              </div>

              <!-- Tab Content -->
              <div class="tab-content">
                <!-- Resumen Tab -->
                <div v-if="viendo_top_menu == 'Resumen'" class="tab-panel">
  <div class="content-card">
    <div class="card-header">
      <div class="card-icon upcoming">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
          <line x1="16" y1="2" x2="16" y2="6"></line>
          <line x1="8" y1="2" x2="8" y2="6"></line>
          <line x1="3" y1="10" x2="21" y2="10"></line>
        </svg>
      </div>
      <h3 class="card-title">Próximas Órdenes</h3>
    </div>
    <div class="card-content">
      <div v-if="profesional.ordenes.filter(x => { return new Date() <= new Date(x.fecha) }).length > 0"
        class="orders-list">
        <div v-for="o in profesional.ordenes.filter(x => { return new Date() <= new Date(x.fecha) })"
          :key="o.id" class="order-item">
          <div class="order-date">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="2">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
              <line x1="16" y1="2" x2="16" y2="6"></line>
              <line x1="8" y1="2" x2="8" y2="6"></line>
              <line x1="3" y1="10" x2="21" y2="10"></line>
            </svg>
            {{ new Date(o.fecha).toLocaleDateString("es-ES", {
              year: 'numeric', month: 'long', day:
            'numeric' }) }}
          </div>
          <div class="order-details">
            <span class="patient-name">{{ o.nombre }} {{ o.apellido1 }}</span>
            <span class="order-location">{{ o.direccion }}, {{comunas.find(x => x.id ==
              o.comuna_id).Nombre }}</span>
            <span class="patient-name">{{ getPrestador(o.prestador_id).nombre }}</span>
            <!-- MOSTRAR EXÁMENES -->
            <div v-if="o.examenes_nombres && o.examenes_nombres.length > 0" class="examenes-list">
              <span class="examenes-label">Exámenes:</span>
              <span class="examenes-nombres">{{ o.examenes_nombres.join(', ') }}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="empty-state">
        <div class="empty-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="1.5">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
            <line x1="16" y1="2" x2="16" y2="6"></line>
            <line x1="8" y1="2" x2="8" y2="6"></line>
            <line x1="3" y1="10" x2="21" y2="10"></line>
          </svg>
        </div>
        <p>No hay órdenes próximas programadas</p>
      </div>
    </div>
  </div>

  <div class="content-card">
    <div class="card-header">
      <div class="card-icon recent">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2">
          <circle cx="12" cy="12" r="10"></circle>
          <polyline points="12,6 12,12 16,14"></polyline>
        </svg>
      </div>
      <h3 class="card-title">Actividad Reciente</h3>
    </div>
    <div class="card-content">
      <div v-if="profesional.ordenes.filter(x => { return new Date() >= new Date(x.fecha) }).length > 0"
        class="orders-list">
        <div v-for="o in profesional.ordenes.filter(x => { return new Date() >= new Date(x.fecha) })"
          :key="o.id" class="order-item completed">
          <div class="order-date">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <polyline points="22,4 12,14.01 9,11.01"></polyline>
            </svg>
            {{ new Date(o.fecha).toLocaleDateString("es-ES", {
              year: 'numeric', month: 'long', day:
            'numeric' }) }}
          </div>
          <div class="order-details">
            <span class="patient-name">{{ o.nombre }} {{ o.apellido1 }}</span>
            <span class="order-location">{{ o.direccion }}, {{comunas.find(x => x.id ==
              o.comuna_id).Nombre }}</span>
            <span class="patient-name">{{ getPrestador(o.prestador_id).nombre }}</span>
            <!-- MOSTRAR EXÁMENES -->
            <div v-if="o.examenes_nombres && o.examenes_nombres.length > 0" class="examenes-list">
              <span class="examenes-label">Exámenes:</span>
              <span class="examenes-nombres">{{ o.examenes_nombres.join(', ') }}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="empty-state">
        <div class="empty-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="1.5">
            <circle cx="12" cy="12" r="10"></circle>
            <polyline points="12,6 12,12 16,14"></polyline>
          </svg>
        </div>
        <p>No hay actividad reciente registrada</p>
      </div>
    </div>
  </div>
</div>

                <!-- Calendario Tab -->
                <div v-else-if="viendo_top_menu == 'Calendario'" class="tab-panel">
                  <div class="content-card">
                    <div v-if="loaded_calendario" class="calendar-container">
                      <div class="calendar-header">
                        <button class="calendar-nav-btn"
                          :style="{ 'background-color': prestador.admin.assets.colors.primary }"
                          @click="semanaAnterior();">
                          <i class="tf-icons ti ti-arrow-narrow-left"></i>
                          <span class="nav-text">Semana Anterior</span>
                        </button>

                        <div class="calendar-title">
                          Semana del {{ desdeD.getDate() }} de {{ meses[desdeD.getMonth()] }} del {{
                          desdeD.getFullYear() }}
                        </div>

                        <button class="calendar-nav-btn"
                          :style="{ 'background-color': prestador.admin.assets.colors.primary }"
                          @click="semanaSiguiente()">
                          <span class="nav-text">Semana Siguiente</span>
                          <i class="tf-icons ti ti-arrow-narrow-right"></i>
                        </button>
                      </div>

                      <div class="calendar-grid">
                        <div class="calendar-time-column">
                          <div class="time-header">Horario</div>
                          <div v-for="i in Math.ceil((horaMax - horaMin) / 60)" :key="i" class="time-slot">
                            {{ timeConvert(horaMin + (i - 1) * 60) }}-{{ timeConvert(horaMin + (i) * 60) }}
                          </div>
                        </div>

                        <div class="calendar-days-container">
                          <div class="calendar-days-header">
                            <div v-for="d, i in dias2" :key="i" class="day-header">
                              {{ d }} {{ viendoSemana[i] }}
                            </div>
                          </div>

                          <div class="calendar-grid-body">
                            <div v-for="i in Math.ceil((horaMax - horaMin) / 60)" :key="i" class="time-row"
                              :style="{ 'top': (50 * (i - 1)) + 'px' }"></div>

                            <div v-for="h in calendario.ordenes"
                              v-if="new Date(h.fecha.a, h.fecha.m - 1, h.fecha.d) >= desdeD && new Date(h.fecha.a, h.fecha.m - 1, h.fecha.d) <= hastaD"
                              :key="h.id" class="calendar-event" :style="{
                                'left': (14.28 * (viendoSemana.findIndex(x => { return x == h.fecha.d }))).toString() + '%',
                                'height': (50 * (h.hasta - h.desde) / 60) + 'px',
                                'top': (((h.desde - horaMin) * 50 / 60)).toString() + 'px',
                                'background': h.estado == 2 ? 'linear-gradient(135deg, #606dbc, #465298)' : h.estado == 1 ? 'linear-gradient(135deg, #FF851B, #fcb577)' : 'linear-gradient(135deg, #3D9970, #549c7c)'
                              }">
                              <div class="event-content">
                                <span class="event-id">ID: {{ h.id }}</span>
                                <span class="event-id">ID: {{ getPrestador(h.prestador_id).nombre }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else class="loading-container">
                      <Loader :height="100" :width="100" />
                    </div>
                  </div>
                </div>

                <!-- Horarios Tab -->
                <div v-else-if="viendo_top_menu == 'Horarios'" class="tab-panel">
                  <div class="content-card">
                    <div class="card-header">
                      <div class="card-icon schedule">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                          stroke-width="2">
                          <circle cx="12" cy="12" r="10"></circle>
                          <polyline points="12,6 12,12 16,14"></polyline>
                        </svg>
                      </div>
                      <h3 class="card-title">Horarios de Atención</h3>
                      <button class="add-schedule-btn"
                        :style="{ 'background-color': prestador.admin.assets.colors.primary }"
                        @click="$refs.modalagregarhorario.show()">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                          stroke-width="2">
                          <line x1="12" y1="5" x2="12" y2="19"></line>
                          <line x1="5" y1="12" x2="19" y2="12"></line>
                        </svg>
                        Agregar Horario
                      </button>
                    </div>

                    <div class="card-content">
                      <div class="schedule-table-container">
                        <table class="schedule-table">
                          <thead>
                            <tr>
                              <th>Prestadores Activos</th>
                              <th>Alias</th>
                              <th>Días</th>
                              <th>Horario</th>
                              <th>Comunas</th>
                              <th>Categorías</th>
                              <th>Intervalo</th>
                              <th>Anticipación</th>
                              <th>Prioridad</th>
                              <th>Acciones</th>
                              <th>Clonar</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="h in profesional.horarios" :key="h.id" class="schedule-row">
                              <td>
                                <div class="days-tags">
                                  <template v-if="h.prestadores_activos && h.prestadores_activos.length">
                                    <span v-for="pid in h.prestadores_activos" :key="pid" class="alias-tag">({{
                                      getPrestador(pid).nombre }})</span>
                                  </template>
                                  <span v-else class="alias-tag">Prestador no asignado</span>
                                </div>
                              </td>
                              <td class="days-cell">
                                <div class="days-tags">
                                  <span>
                                    <!-- {{ h.nombre || 'Horario ' + h.id }} -->
                                    <span v-if="h.alias" class="alias-tag">({{ h.alias.nombre_alias }})</span>
                                  </span>
                                </div>
                              </td>
                              <td class="days-cell">
                                <div class="days-tags">
                                  <span v-for="r, i in h.repeticion" v-if="r == 1" :key="i" class="day-tag">
                                    {{ dias[i] }}{{ i == h.repeticion.lastIndexOf('1') ? '' : ',' }}
                                  </span>
                                </div>
                              </td>
                              <td class="time-cell">
                                <div class="time-range">
                                  {{ timeConvert(h.inicio) }} - {{ timeConvert(h.termino) }}
                                </div>
                              </td>
                              <td class="location-cell">
                                <div class="location-list">
                                  <span v-for="c in h.comunas" :key="c" class="location-item">
                                    {{comunas.filter(x => { return x.id == c })[0].Nombre}}
                                  </span>
                                </div>
                              </td>
                              <td class="category-cell">
                                <div class="category-list">
                                  <span v-for="c in h.categorias" :key="c" class="category-item">
                                    {{categorias.filter(x => { return x.id == c })[0].nombre}}
                                  </span>
                                </div>
                              </td>
                              <td class="interval-cell">
                                <span class="interval-badge">{{ h.intervalo }} min</span>
                              </td>
                              <td class="anticipation-cell">
                                <span class="anticipation-badge">{{ timeConvert2(h.anticipacion) }}</span>
                              </td>
                              <td class="priority-cell">
                                <span class="priority-badge" :class="'priority-' + h.prioridad">{{ h.prioridad }}</span>
                              </td>
                              <td class="actions-cell">
                                <router-link :to="'/ModificarHorarioPro/' + $route.params.id + '/' + h.id" class="edit-link">
                                  <button class="edit-btn" :style="{ 'color': prestador.admin.assets.colors.primary }">
                                    <i class="tf-icons ti ti-pencil"></i>
                                  </button>
                                </router-link>
                              </td>
                              <td class="actions-cell">
                                <button @click="copy_horario_prestador(h.id)"  class="edit-btn" :style="{ 'color': prestador.admin.assets.colors.primary }">
                                  <i class="tf-icons ti ti-clipboard"></i>
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>


                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Loading State -->
        <div v-else class="loading-state">
          <div class="loading-container">
            <Loader :height="100" :width="100" />
            <p class="loading-text">Cargando información del profesional...</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from 'axios';
import { mapGetters, mapActions } from 'vuex';
import Fuse from 'fuse.js'
import SideNav from '@/components/SideNav.vue';
import Loader from '@/components/Loader.vue';
import TopNav from '@/components/TopNav.vue';
import ModalAgregarHorario from './utils/ModalAgregarHorario.vue';
import ModalModificarProfesional from './utils/ModalModificarProfesional.vue';
import ModalModificarAtencionPrestador from './utils/ModalModificarAtencionPrestador.vue';


export default {
  name: 'Profesional',
  props: ['id'],
  components: {
    SideNav,
    Loader,
    TopNav,
    ModalAgregarHorario,
    ModalModificarProfesional,
    ModalModificarAtencionPrestador
  },
  data() {
    return {
      loaded: false,
      profesional: {},
      categorias: {},
      top_menu: [
        { nombre: 'Resumen', icono: 'ti-user-check' },
        { nombre: 'Calendario', icono: 'ti-calendar' },
        // {nombre:'Ordenes', icono:'ti-shopping-cart'},
        { nombre: 'Horarios', icono: 'ti-clock' },
        // {nombre:'Calificaciones', icono:'ti-star'},
      ],
      viendo_top_menu: 'Resumen',


      hastaD: 0,
      desdeD: 0,
      loaded_calendario: false,
      calendario: { ordenes: [], bloqueos: [] },
      mapping: [6, 0, 1, 2, 3, 4, 5],
      dias: ['Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa', 'Dom'],
      dias2: ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sabado', 'Domingo'],
      meses: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Nobiembre', 'Diciembre'],

      prestadores: [],
      prestadores_activos: [],

      mensaje: null,
    }
  },
  created() {

    this.initialize_(this.$route.params.id);
    this.hoy = new Date();
    this.hoyMes = this.hoy.getMonth();
    this.hoyDia = this.hoy.getDate();
    this.hoyAño = this.hoy.getFullYear();
    this.desdeD = new Date()
    this.desdeD.setDate(this.desdeD.getDate() - this.getDia(this.hoyAño, this.hoyMes, this.hoyDia))
    this.hastaD = new Date()
    this.hastaD.setDate(this.hastaD.getDate() + 6 - this.getDia(this.hoyAño, this.hoyMes, this.hoyDia))

    this.viendoDia = this.hoyDia;
    this.viendoMes = this.hoyMes;
    this.viendoAño = this.hoyAño
  },

  methods: {
    ...mapActions(['initialize']),
    getDia(año, mes, dia) {
      return this.mapping[new Date(año, mes, dia).getDay()];

    },
    timeConvert2(n) {
      var num = n;
      var hours = (num / 60);
      var rhours = Math.floor(hours);
      var minutes = (hours - rhours) * 60;
      var rminutes = Math.round(minutes);
      return + rhours + " h " + rminutes + " m.";
    },
    timeConvert(n) {
      var num = n;
      var hours = (num / 60);
      var rhours = Math.floor(hours);
      var minutes = (hours - rhours) * 60;
      var rminutes = Math.round(minutes);
      return (rhours < 10 ? '0' : '') + rhours + ":" + (rminutes < 10 ? '0' : '') + rminutes + "";
    },
    semanaSiguiente() {
      var D = new Date(this.desdeD.getFullYear(), this.desdeD.getMonth(), this.desdeD.getDate())
      D.setDate(D.getDate() + 7)
      this.desdeD = D
      var H = new Date(this.hastaD.getFullYear(), this.hastaD.getMonth(), this.hastaD.getDate())
      H.setDate(H.getDate() + 7)
      this.hastaD = H
      this.ver_calendario();
    },
    semanaAnterior() {
      var D = new Date(this.desdeD.getFullYear(), this.desdeD.getMonth(), this.desdeD.getDate())
      D.setDate(D.getDate() - 7)
      this.desdeD = D
      var H = new Date(this.hastaD.getFullYear(), this.hastaD.getMonth(), this.hastaD.getDate())
      H.setDate(H.getDate() - 7)
      this.hastaD = H
      this.ver_calendario();
    },
    ver_calendario() {
      if (typeof (this.$route.params.id === 'number')) {
        this.loaded_calendario = false;
        axios.post(window.hostname + '/api/admin/ver_calendario_pro',
          {
            profesional_id: this.$route.params.id,
            dia: this.desdeD.getDate(),
            mes: this.desdeD.getMonth() + 1,
            año: this.desdeD.getFullYear(),
            dia2: this.hastaD.getDate(),
            mes2: this.hastaD.getMonth() + 1,
            año2: this.hastaD.getFullYear(),
          })
          .then(response => {
            this.loaded_calendario = true;
            this.calendario.ordenes = response.data.ordenes
            //this.categorias = response.data.categorias
          })

          .catch(e => {
            this.loaded = true;
          })
      }
    },
    getPrestador(id) {
      const prestadores = [
        { nombre: 'Integramédica', prestador_id: 9, color: '#0079c8' },
        { nombre: 'Clínica Alemana', prestador_id: 5, color: '#01a49a' },
        { nombre: 'Laboratorio Blanco', prestador_id: 13, color: '#5e81bc' },
        { nombre: 'UC Christus', prestador_id: 14, color: '#872899' },
        { nombre: 'ClinicGo', prestador_id: 1, color: '#1486e7' },
        { nombre: 'Dávila', prestador_id: 15, color: '#F18A00' },
        { nombre: 'UC Christus En Casa', prestador_id: 16, color: '#872899' },
        { nombre: 'UC Christus Test', prestador_id: 21, color: '#872899' },
        { nombre: 'SportsMD', prestador_id: 18, color: '#2AB042' },
        { nombre: 'Bionet', prestador_id: 3, color: '#0884f4' },
        { nombre: 'Clínica Santa Maria', prestador_id: 22, color: '#536fa6' },
        { nombre: 'Mainque', prestador_id: 2, color: '#4a29d3' },
        { nombre: 'Mainque', prestador_id: 2, color: '#4a29d3' },
        { nombre: 'Clini', prestador_id: 4, color: '#5b398e' },
        { nombre: 'Clic Salud', prestador_id: 6, color: '#5b398e' },
        { nombre: 'Reley', prestador_id: 6, color: '#5b398e' },
        { nombre: 'Regonesi', prestador_id: 8, color: '#008cd5' },
        { nombre: 'CardioPro', prestador_id: 11, color: '#AF0009' },
        { nombre: 'CardioPro', prestador_id: 11, color: '#AF0009' },
        { nombre: 'Nomad', prestador_id: 20, color: '#506C6C' },
        { nombre: 'Testing', prestador_id: 23, color: '#506C6C' },
      ];

      const numericId = Number(id);
      const prestador = prestadores.find(p => p.prestador_id === numericId);
      return prestador ? prestador : { nombre: `Prestador ${id ?? '-'}`, color: '#94a3b8' };
    },
    async initialize_(pid) {
      if (typeof (this.$route.params.id === 'number')) {
        this.profesional = {}
        this.categorias = {}
        this.loaded = false;
        try {
          const response = await axios.post(window.hostname + '/api/admin/init_modificar_pro', { id: pid });
          this.profesional = response.data.profesional;
          this.categorias = response.data.categorias;

          // Cargar alias para cada horario
          if (this.profesional.horarios) {
            for (const horario of this.profesional.horarios) {
              const aliasResponse = await axios.get(window.hostname + `/api/admin/horario/${horario.id}/alias`);
              if (aliasResponse.data.alias && aliasResponse.data.alias.length > 0) {
                // Asignar el primer alias (o puedes modificar para mostrar todos)
                horario.alias = aliasResponse.data.alias[0];
              }
            }
          }

          if (this.profesional.horarios) {
            for (const horario of this.profesional.horarios) {
              this.get_atencion_horario_prestador(horario.id);
            }
          }

          this.$forceUpdate();
          this.loaded = true;
        } catch (e) {
          this.loaded = true;
        }
      }
    },

    copy_horario_prestador(hid) {
      axios.post(window.hostname + `/api/admin/duplicar_horario`, { id: hid })
        .then(resp => {
          this.initialize_(this.$route.params.id)

          this.$notify({
            duration: 5000,
            title: '¡Horario clonado!',
            text: resp.message,
            type: 'success'
          });
        })
        .catch(e => {
          this.$notify({
            duration: 5000,
            title: 'Error!',
            text: e.response?.data?.message || 'Error desconocido',
            type: 'error'
          });
        });
    },

    get_atencion_horario_prestador(hid) {
      axios.get(window.hostname + `/api/admin/horarios/${hid}/atencion_prestador`)
        .then(resp => {
          const catalogo = Array.isArray(resp.data.prestadores) ? resp.data.prestadores : [];
          const activos = Array.isArray(resp.data.prestadores_activos) ? resp.data.prestadores_activos : [];
          this.prestadores = catalogo;

          const horario = (this.profesional.horarios || []).find(x => x.id === hid);
          if (horario) {
            this.$set(horario, 'prestadores_activos', activos);
          }
        })
        .catch(e => {
          this.$notify({
            duration: 5000,
            title: 'Error!',
            text: e.response.data.message,
            type: 'error'
          });
        });
    },
  },
  computed: {
    ...mapGetters(['comunas', 'regiones', 'prestaciones', 'tipos', 'admin_datos', 'prestador']),
    viendoSemana: function () {
      var o;
      var f = [new Date(this.desdeD.getTime())];
      var ret = [this.desdeD.getDate()]
      for (var i = 1; i < 7; i++) {
        o = new Date(f[i - 1].getTime())
        o.setDate(o.getDate() + 1)
        f.push(o)
        ret.push(o.getDate())
      }

      return ret;

    },
    horaMin: function () {
      var min = 360;
      for (var i = 0; i < this.profesional.horarios.length; i++) {
        for (var j = 0; j < this.profesional.horarios[i].ordenes.length; j++) {
          if (this.profesional.horarios[i].ordenes[j].desde < min) {
            min = this.profesional.horarios[i].ordenes[j].desde
          }
        }

      }
      return min
    },

    horaMax: function () {
      var max = 1080;
      for (var i = 0; i < this.profesional.horarios.length; i++) {
        for (var j = 0; j < this.profesional.horarios[i].ordenes.length; j++) {
          if (this.profesional.horarios[i].ordenes[j].desde > max) {
            max = this.profesional.horarios[i].ordenes[j].desde
          }
        }

      }
      return max
    },
  },
  mounted() {
    this.fComunas = new Fuse(this.comunas, { keys: ['Nombre'] })
    this.$root.$on('recargar_profesionales', async () => {
      await this.initialize_(this.$route.params.id);


    });
  },
  watch: {
    comunas_buscadas(val) {
      this.resultado_fuse_comuna = this.fComunas.search(val)

    },
    viendo_top_menu(val) {
      if (val == "Calendario") {
        this.ver_calendario()
      }


    },
  }

}
</script>


<style scoped>
/* Base Styles - Notion-inspired with medical touches */
.medical-professional-wrapper {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
}

.column-left {
  position: fixed;
  left: 0;
  top: 0;
  width: 280px;
  height: 100vh;
  z-index: 1000;
}

.column-right {
  margin-left: 280px;
  min-height: 100vh;
}

.main-container {
  padding: 0;
}

.professional-content {
  padding: 2rem;
  max-width: 1900px;
  margin: 0 auto;
}

/* Professional Layout */
.professional-layout {
  display: grid;
  grid-template-columns: 400px 1fr;
  gap: 2rem;
  align-items: start;
}

/* Profile Card */
.profile-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
  border: 1px solid #e2e8f0;
  overflow: hidden;
  position: sticky;
  top: 2rem;
}

.profile-header {
  padding: 2rem;
  text-align: center;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
}

.profile-avatar-container {
  position: relative;
  display: inline-block;
  margin-bottom: 1.5rem;
}

.profile-avatar {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background-position: center;
  background-size: cover;
  border: 4px solid #e2e8f0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
}

.profile-status-indicator {
  position: absolute;
  bottom: 8px;
  right: 8px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 3px solid white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.profile-info {
  text-align: center;
}

.profile-name {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
}

.edit-profile-btn {
  background: none;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 16px;
}

.edit-profile-btn:hover {
  border-color: currentColor;
  background-color: rgba(59, 130, 246, 0.05);
  transform: scale(1.05);
}

.profile-role {
  font-size: 1rem;
  color: #64748b;
  margin: 0;
  font-weight: 500;
}

.profile-divider {
  height: 1px;
  background: #e2e8f0;
  margin: 0;
}

/* Profile Details */
.profile-details {
  padding: 2rem;
}

.details-header {
  margin-bottom: 1.5rem;
}

.details-header h3 {
  font-size: 1.125rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
}

.details-grid {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.detail-item {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.detail-item.full-width {
  grid-column: 1 / -1;
}

.detail-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: #64748b;
}

.detail-icon {
  color: #94a3b8;
}

.detail-value {
  font-size: 0.875rem;
  color: #1e293b;
  font-weight: 500;
}

/* Tags and Badges */
.provider-tags,
.location-tags,
.category-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.provider-tag,
.location-tag,
.category-tag {
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  border: 1px solid;
}

.time-badge {
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
  color: white;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
}

.modify-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.modify-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(59, 130, 246, 0.3);
}

/* Content Area */
.content-area {
  background: white;
  border-radius: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
  border: 1px solid #e2e8f0;
  overflow: hidden;
}

/* Tab Navigation */
.tab-navigation {
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  padding: 1rem 2rem 0;
}

.tab-container {
  display: flex;
  gap: 0.5rem;
}

.tab-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  border: 2px solid #e2e8f0;
  border-bottom: none;
  border-radius: 12px 12px 0 0;
  background: white;
  color: #64748b;
  font-weight: 600;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  top: 1px;
}

.tab-button:hover {
  border-color: #cbd5e1;
  background-color: #f8fafc;
}

.tab-button.active {
  border-color: currentColor;
  background-color: currentColor;
  color: white;
}

.tab-icon {
  font-size: 16px;
}

.tab-text {
  font-weight: 600;
}

/* Tab Content */
.tab-content {
  padding: 2rem;
}

.tab-panel {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

/* Content Cards */
.content-card {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
}

.card-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.5rem;
  background: white;
  border-bottom: 1px solid #e2e8f0;
}

.card-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.card-icon.upcoming {
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
}

.card-icon.recent {
  background: linear-gradient(135deg, #10b981, #059669);
}

.card-icon.schedule {
  background: linear-gradient(135deg, #f59e0b, #d97706);
}

.card-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
  flex: 1;
}

.add-schedule-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.add-schedule-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(59, 130, 246, 0.3);
}

.card-content {
  padding: 1.5rem;
}

/* Orders List */
.orders-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.order-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.order-item:hover {
  border-color: #cbd5e1;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.order-item.completed {
  opacity: 0.8;
}

.order-date {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: #64748b;
  min-width: 200px;
}

.order-details {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  flex: 1;
}

.patient-name {
  font-weight: 600;
  color: #1e293b;
  font-size: 0.875rem;
}

.order-location {
  font-size: 0.75rem;
  color: #64748b;
}

.examenes-list {
  margin-top: 0.5rem;
  padding-top: 0.5rem;
  border-top: 1px solid #e2e8f0;
}

.examenes-label {
  font-weight: 600;
  color: #374151;
  font-size: 0.875rem;
  margin-right: 0.5rem;
}

.examenes-nombres {
  color: #6b7280;
  font-size: 0.875rem;
  font-style: italic;
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 3rem 1rem;
}

.empty-icon {
  color: #94a3b8;
  margin-bottom: 1rem;
}

.empty-state p {
  color: #64748b;
  font-size: 0.875rem;
  margin: 0;
}

/* Calendar Styles */
.calendar-container {
  background: white;
  border-radius: 8px;
}

.calendar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid #e2e8f0;
  gap: 1rem;
}

.calendar-nav-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
  color: white;
  border: none;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.calendar-nav-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(59, 130, 246, 0.3);
}

.calendar-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: #1e293b;
  text-align: center;
}

.calendar-grid {
  display: flex;
  min-height: 400px;
}

.calendar-time-column {
  width: 120px;
  border-right: 1px solid #e2e8f0;
}

.time-header {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  color: #64748b;
  font-size: 0.875rem;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
}

.time-slot {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  color: #64748b;
  border-bottom: 1px solid #f1f5f9;
  padding: 0 0.5rem;
  text-align: center;
}

.calendar-days-container {
  flex: 1;
  position: relative;
}

.calendar-days-header {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  height: 50px;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
}

.day-header {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  color: #64748b;
  font-size: 0.875rem;
  border-right: 1px solid #f1f5f9;
}

.calendar-grid-body {
  position: relative;
  min-height: 350px;
}

.time-row {
  position: absolute;
  left: 0;
  right: 0;
  height: 1px;
  background: #f1f5f9;
}

.calendar-event {
  position: absolute;
  width: 14.28%;
  border-radius: 4px;
  color: white;
  font-size: 0.75rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.event-content {
  text-align: center;
  padding: 0.25rem;
}

.event-id {
  font-size: 0.75rem;
}

/* === Ajustes Responsivos — Manteniendo la columna de horas a la izquierda === */

/* Contenedor general */
.calendar-container {
  overflow: hidden;
  width: 100%;
}

/* La grilla completa será scrollable horizontalmente */
.calendar-grid {
  display: flex;
  min-height: 400px;
  overflow-x: auto; /* 🔹 scroll horizontal si es necesario */
  overflow-y: hidden;
  position: relative;
}

/* Fijamos la columna de horarios a la izquierda */
.calendar-time-column {
  flex-shrink: 0;
  width: 120px;
  background: #fff;
  border-right: 1px solid #e2e8f0;
  position: sticky; /* 🔹 mantiene fija la columna en scroll horizontal */
  left: 0;
  z-index: 5;
}

/* El contenedor de los días puede desplazarse sin mover las horas */
.calendar-days-container {
  flex: 1;
  min-width: 700px; /* 🔹 asegura que entren los 7 días */
  overflow-x: auto;
}

/* Ajustes del header en pantallas chicas */
@media (max-width: 992px) {
  .calendar-header {
    flex-wrap: wrap;
    justify-content: center;
    gap: 0.75rem;
  }

  .calendar-title {
    font-size: 1rem;
    text-align: center;
    width: 100%;
  }

  .calendar-nav-btn {
    font-size: 0.8rem;
    padding: 0.6rem 0.8rem;
  }
}

/* En móviles: reducimos fuentes y activamos scroll horizontal */
@media (max-width: 768px) {
  .calendar-grid {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .calendar-days-container {
    min-width: 600px;
  }

  .calendar-days-header .day-header {
    font-size: 0.7rem;
    padding: 0 0.25rem;
  }

  .time-header,
  .time-slot {
    font-size: 0.7rem;
    padding: 0.25rem;
  }

  .calendar-event {
    font-size: 0.65rem;
    padding: 0.2rem;
  }
}

/* Móviles angostos */
@media (max-width: 480px) {
  .calendar-header {
    flex-direction: column;
    align-items: stretch;
  }

  .calendar-title {
    order: -1;
  }

  .calendar-nav-btn {
    width: 100%;
    justify-content: center;
  }
}


/* Schedule Table */
.schedule-table-container {
  overflow-x: auto;
}

.schedule-table {
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 8px;
  overflow: hidden;
}

.schedule-table th {
  background: #f8fafc;
  padding: 1rem;
  text-align: left;
  font-weight: 600;
  color: #64748b;
  font-size: 0.875rem;
  border-bottom: 1px solid #e2e8f0;
}

.schedule-table td {
  padding: 1rem;
  border-bottom: 1px solid #f1f5f9;
  vertical-align: top;
}

.schedule-row:hover {
  background-color: #f8fafc;
}

.days-tags,
.location-list,
.category-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
}

.day-tag,
.location-item,
.category-item {
  font-size: 0.75rem;
  color: #64748b;
}

.time-range {
  font-weight: 600;
  color: #1e293b;
  font-size: 0.875rem;
}

.interval-badge,
.anticipation-badge {
  background: #f1f5f9;
  color: #64748b;
  padding: 0.25rem 0.5rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
}

.priority-badge {
  padding: 0.25rem 0.5rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  color: white;
}

.priority-badge.priority-1 {
  background: linear-gradient(135deg, #ef4444, #dc2626);
}

.priority-badge.priority-2 {
  background: linear-gradient(135deg, #f59e0b, #d97706);
}

.priority-badge.priority-3 {
  background: linear-gradient(135deg, #10b981, #059669);
}

.edit-link {
  text-decoration: none;
}

.edit-btn {
  background: none;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 16px;
}

.edit-btn:hover {
  border-color: currentColor;
  background-color: rgba(59, 130, 246, 0.05);
  transform: scale(1.05);
}

/* Loading State */
.loading-state {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  background: white;
  padding: 3rem;
  border-radius: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
  border: 1px solid #e2e8f0;
}

.loading-text {
  color: #64748b;
  font-size: 1rem;
  font-weight: 500;
  margin: 0;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .column-right {
    margin-left: 0;
  }

  .professional-layout {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .profile-card {
    position: static;
  }
}

@media (max-width: 768px) {
  .professional-content {
    padding: 1rem;
  }

  .profile-header {
    padding: 1.5rem;
  }

  .profile-avatar {
    width: 100px;
    height: 100px;
  }

  .profile-name {
    font-size: 1.25rem;
    flex-direction: column;
    gap: 0.5rem;
  }

  .profile-details {
    padding: 1.5rem;
  }

  .tab-navigation {
    padding: 1rem;
  }

  .tab-container {
    flex-wrap: wrap;
  }

  .tab-button {
    padding: 0.5rem 1rem;
    font-size: 0.75rem;
  }

  .tab-text {
    display: none;
  }

  .tab-content {
    padding: 1rem;
  }

  .card-header {
    padding: 1rem;
    flex-direction: column;
    align-items: stretch;
    gap: 1rem;
  }

  .calendar-header {
    flex-direction: column;
    gap: 1rem;
  }

  .calendar-nav-btn .nav-text {
    display: none;
  }

  .schedule-table-container {
    font-size: 0.75rem;
  }

  .schedule-table th,
  .schedule-table td {
    padding: 0.5rem;
  }

  .tab-container {
    flex-wrap: nowrap;
    /* Evita que se envuelvan */
    overflow-x: auto;
    /* Permite desplazamiento horizontal */
    -webkit-overflow-scrolling: touch;
    /* Scroll suave en iOS */
    padding-bottom: 8px;
    /* Espacio para el scroll */
  }

  .tab-button {
    padding: 0.75rem 1rem;
    /* Más grande que en tu versión actual */
    flex-shrink: 0;
    /* Evita que se encojan */
    white-space: nowrap;
    /* Evita saltos de línea */
    z-index: 1000;
  }

  /* Muestra el texto en móviles también */
  .tab-text {
    display: inline-block !important;
    font-size: 0.75rem;
  }
}

@media (max-width: 480px) {
  .professional-content {
    padding: 0.5rem;
  }

  .profile-card,
  .content-area {
    border-radius: 12px;
  }

  .profile-header {
    padding: 1rem;
  }

  .profile-avatar {
    width: 80px;
    height: 80px;
  }

  .profile-name {
    font-size: 1.125rem;
  }

  .profile-details {
    padding: 1rem;
  }

  .tab-content {
    padding: 0.5rem;
  }

  .card-content {
    padding: 1rem;
  }

  .order-item {
    flex-direction: column;
    align-items: stretch;
    gap: 0.75rem;
  }

  .order-date {
    min-width: auto;
  }

  .calendar-grid {
    min-height: 300px;
  }

  .time-slot {
    font-size: 0.625rem;
    padding: 0 0.25rem;
  }
}

/* Focus States */
.edit-profile-btn:focus,
.modify-btn:focus,
.tab-button:focus,
.add-schedule-btn:focus,
.calendar-nav-btn:focus,
.edit-btn:focus {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}

/* High Contrast Mode */
@media (prefers-contrast: high) {

  .profile-card,
  .content-area,
  .content-card {
    border-width: 2px;
  }

  .tab-button,
  .edit-profile-btn,
  .edit-btn {
    border-width: 2px;
  }
}

/* Reduced Motion */
@media (prefers-reduced-motion: reduce) {

  .profile-avatar,
  .edit-profile-btn,
  .modify-btn,
  .tab-button,
  .add-schedule-btn,
  .calendar-nav-btn,
  .order-item,
  .edit-btn {
    transition: none;
  }
}

/* Dark mode support (if needed) */
@media (prefers-color-scheme: dark) {
  .medical-professional-wrapper {
    background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
  }

  .profile-card,
  .content-area,
  .content-card {
    background: #1e293b;
    border-color: #334155;
  }

  .profile-header,
  .card-header,
  .tab-navigation {
    background: #0f172a;
    border-bottom-color: #334155;
  }

  .profile-name,
  .card-title,
  .calendar-title,
  .patient-name,
  .time-range {
    color: #e2e8f0;
  }

  .profile-role,
  .detail-label,
  .detail-value,
  .order-date,
  .order-location,
  .empty-state p,
  .loading-text {
    color: #94a3b8;
  }

  .tab-button {
    background: #1e293b;
    border-color: #334155;
    color: #94a3b8;
  }

  .tab-button:hover {
    background: #0f172a;
  }

  .order-item {
    background: #0f172a;
    border-color: #334155;
  }

  .schedule-table {
    background: #1e293b;
  }

  .schedule-table th {
    background: #0f172a;
    color: #94a3b8;
    border-bottom-color: #334155;
  }

  .schedule-table td {
    border-bottom-color: #334155;
  }

  .schedule-row:hover {
    background: #0f172a;
  }
}

@media (max-width: 1200px) {
  .column-left {
    z-index: 0;
    width: 0px;
  }
}
</style>